export default __webpack_public_path__ + "8eacc25dd2f40e63e47aebe8af703d27.obj";